import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import DropArea from '../components/SenderDropArea'; 
import BottomNavigation from '../components/BottomNavigation.js';
import ReceiverList from '../components/ReceiverList';
import SettingsDialog from '../components/SettingsDialog';
import UserInfo from '../components/UserInfo';
import DownloadList from '../components/DownloadList';
import FilePermissionDialog from '../components/FilePermissionDialog';
import { Loader } from '../components/Loader';
import { SettingsIconBtn, LeaveRoomBtn, RoomDetails, ShareViaAudioIconButton, QrButton } from '../components/Button';
import { FileDownloadStatsBar } from '../components/ProgressBar';
import { SuccessToast,FileSeedingStatusToast } from '../components/Toast';
import { Player, Controls } from '@lottiefiles/react-lottie-player';
import folder from '../json/folder.json';
import connect from '../json/connect.json';
import Analyzer from '../sonic/executor';
import NoSleep from 'nosleep.js';
import { toast } from 'react-toastify';
import '../css/RoomMobile.css';
import CreateRoomDialog from '../components/CreateRoomDialog';
import UserContext from '../context/userContext'
import ReceiverPrompt from '../components/ReceiverPrompt';
import Logo from '../components/Logo';
import ReceiverTextPrompt from '../components/ReceiverTextPrompt';
import InfoPrompt from '../components/InfoPrompt';
import QrPrompt from '../components/QrPrompt';
import PrivatePrompt from '../components/PrivatePrompt';
var QRCode = require('qrcode')


var noSleep = new NoSleep();

class Room extends Component{

    constructor(props){
        super(props);
        this.state = {
            roomName : null,
            sender : null,
            openSettings : false,
            openDetails : false,
            curPeers : {},
            receivers : [],
            roomIsPublic : true,
            files : [],
            openToast : false,
            fileOpen : false,
            leaveRoom : false,
            downloadStatus: null,
            downloadFiles : [],
            displayComponent : 0,
            errCode : "",
            fileCallBack : null,
            filePermList : "",
            filePermPrompt : false,
            createRoomDialogFlag : localStorage.getItem('UserName') ? false : true,
            successMsg : "",
            successToast: false,
            renderGif: true,
            analyzer : null,
            clipboardStream : false,
            audioDisplay : true,
            clipTextField : "",
            receiverClipText : "",
            promptArr : [],
            openRoomTextPrompt : false,
            openAudioInfoPrompt : false,
            fPrivate:false,
            openQrPrompt : false,
            qrcode : null,
            isSigned:false,
            setAuth: false
        }
        
    }
    static contextType = UserContext;

    sonic = ()=> {        
        let bootstrap = (p)=> {

            let config = {
                alphabet: '^ABCDEFGHIJKLMNOPQRSTUVWXYZ_$',
                data: 'A',
                charDuration: 0.2,
                rampDuration: 0.09,
                freqMin: 10500,
                freqMax: 12500,
                freqError: 50,
                threshold: 0,
                energyFilter: 115,
            }
            
            let analyzer = new Analyzer(p, config);



            let cb = (params, energy, success, activate) => {
                if (params[0] === "^" && params[params.length-1] === "$"){
                    params = params.slice(1,params.length-1)
                    params = params.split("").filter((e) => e != "_")
                    // document.querySelector("h2").innerHTML ="Result: "+params.join("")
                    let roomCode = params.join("");
                    if(roomCode.length === 9 || roomCode.length === 12){
                        roomCode = roomCode.slice(0,3)+'-'+roomCode.slice(3,6)+'-'+roomCode.slice(6,9);
                        this.setState({ roomCode });
                    }
                    console.log("[INFO] RECORDED", params.join(""), energy, success);
                }
            }



            p.setup = () => {
                analyzer.setup();
            }

            p.touchStarted = () => {
                p.getAudioContext().resume();
            }

            p.draw = () => {
                analyzer.draw();
            }

            analyzer.init(cb);

            this.setState({ analyzer });
        }

        new this.context.p5(bootstrap);

}

    // public & private room
    handleVisibility = (data) => { 
        this.context.teleport.setVisibility(data)
    }

    handleKeyChange = () => {

        this.context.teleport.generateNewCredentials((words) => {
            localStorage.setItem("createRoom",words);
            this.setState({
                roomName:words,
                openSettings: false,
                // successToast: true,
                // successMsg: "Default Room Code Changed!"
            })
            toast.success("Default Room Code Changed!");
        })
    }

    createNotification = (text) => {
        if(!document.hidden) {
            toast.info(text,{toastId:text})
        } else {
            if (('Notification' in window)) {
              Notification.requestPermission((permission) => {
                if(!('permission' in Notification)) {
                    Notification.permission = permission;
                }
                if (permission === "granted") {
                  navigator.serviceWorker.ready.then((registration) => {
                    registration.showNotification('Teleport',{ body: text,data:{href:window.location.href,name:""}});
                  });
                }
              });
            }
        }
    } 

    handleAutoClip = async (value) => {
        try{
            await navigator.clipboard.writeText(value||this.state.receiverClipText);
            toast.info("Clipboard updated with "+this.state.receivers[0].nickname+"'s text content!",{toastId:"123"});
        } catch (e) {
            console.log(e)
        }
    }

    componentDidMount() {


        window.addEventListener('popstate',(e)=>{
            e.preventDefault();
            this.setState({ leaveRoom : true })
        })

        this.context.teleport.onSwitch(() => {
            // this.setState({ 
            //     successToast: true,
            //     successMsg: "Switched To Torrent"
            // })
            toast.success("Switched To Torrent");
        })
        this.context.teleport.onAcceptFile (({files,isLast},cb) => {
            if(localStorage.getItem('configFile') == 'false'){
                cb("string")
            } else {
                //Ensure file prompt is set only once per set of files
                if (!this.state.filePermPrompt) {
                  this.setState({
                    fileCallBack: cb,
                    fileOpen: true,
                    filePermList: 'Accept Files :' + files.map((x) => x.name).join(),
                    filePermPrompt: true,
                  })
                } else {
                  cb('string')
                }
                if (isLast) {
                  //Last chunk of file to get transferred
                  this.setState({
                    filePermPrompt: false,
                  })
                }
            }
            
          })

        //Sender Dies change reflect on Receivers
        this.context.teleport.setOnceMasterLeft(()=>{ 
            this.setState({ errCode : "Sender has stopped sharing!" ,leaveRoom : true })
        })

        this.context.teleport.onPeerUpdate((peerList) => {    
            let temp = peerList.reduce((acc,cur) => {
                if(cur._id in this.state.curPeers){
                    acc[cur._id] = this.state.curPeers[cur._id]
                } else {
                    acc[cur._id] = "Awaiting"
                }
                return acc
             },{})
             if(this.state.sender.name === 'slave' && peerList.length && this.state.roomName !== 's-o-c'){
                let joinroom = JSON.parse(localStorage.getItem('joinRoom')) || {};
                joinroom[peerList[0].nickname] = this.state.roomName;
                localStorage.setItem('joinRoom',JSON.stringify(joinroom));
            }
            this.setState({
                receivers: peerList,
                curPeers: temp
            })
        })

        this.context.teleport.onPeerStatus((curPeers) => { 
            curPeers = new Set(curPeers);

            let temp = Object.keys(this.state.curPeers).reduce((acc,cur) => {
                if(curPeers.has(cur)){
                    acc[cur] = "Sending"
                 } else{
                    if(this.state.curPeers[cur] === "Sending"){
                        acc[cur] = "Sent"
                    } else {
                        acc[cur] = this.state.curPeers[cur]
                    }
                }
                return acc
            },{});
            this.setState({curPeers: temp});
            (Object.values(temp).reduce((acc, cur) => {
                return acc && (cur === 'Sent')
            },true))? this.createNotification("File Transfer Completed!") : console.log("") 
        })

        if(!this.state.createRoomDialogFlag){
            this.handlePrivateRoom()
        }

        this.sonic();
        noSleep.enable();

        if(this.context.webShare && typeof(this.context.webShare) !== "string") {
            let files = this.context.webShare;
            this.setState({files});
            this.setFile(files);
            this.context.setWs(null)
        }

        this.context.teleport.setGetPermission(({nickname,sockid,event}) => {
            let con = localStorage.getItem('configReceiver');
            if((!this.state.fPrivate)&&(!(con) || con == 'false')){
                return Promise.resolve(true)
            } else {
                if(event === 'join'){
                    return new Promise((res, rej) =>{
                        this.setState({
                            promptArr: [...this.state.promptArr,{name:nickname,res,sock:sockid}]
                        })
                    })
                } else{
                    this.setState({promptArr:this.state.promptArr.filter(prompt => prompt.sock != sockid)})
                }
            }
        })

        let sample = () => {
            this.handleAutoClip();
            window.removeEventListener("focus",sample);
        }

        //Clipboard feature for receiver prompt
        this.context.teleport.setTextDataChange((value)=>{
            if(value) {
                let autoClip = localStorage.getItem('autoClip')||false;
                autoClip = (autoClip) ? (autoClip=='true') : false;
                if(autoClip) {
                    if(document.hidden) {
                        window.addEventListener("focus", sample)
                    } else {
                        this.handleAutoClip(value)
                    }
                    this.setState({
                        receiverClipText : value,
                    })
                } else{
                    this.setState({
                        receiverClipText : value,
                        openRoomTextPrompt : true,
                    })
                }
                if(document.hidden) {
                    this.createNotification("Received text data from "+ this.state.receivers[0].nickname);
                }
            } else {
                this.setState({ 
                    receiverClipText : "",
                    openRoomTextPrompt : false,
                })
            }
        })

        //Kick receivers
        this.context.teleport.setForceLeave(()=>{
            this.handleLeaveRoom();
        })

    }

    ejectPeer = (peerID) => {
        this.context.teleport.ejectPeer(peerID);
    }

    sendTextContent = (text) => {
        this.context.teleport.sendTextData(text);
    }

    componentWillUnmount() {
        try{
            noSleep.disable();
        } catch(err) {
            console.log(err+"wakelock")
        }
    }

    readClip = async () => {
        let text;
        if (navigator.clipboard) {
            text = await navigator.clipboard.readText();
        }
        this.setState({ clipTextField: text });
    }

    renderUserPrompt = () => {
        if(this.state.promptArr.length > 0){
            let handler = (bool) => {
                if(bool){
                    this.state.promptArr[0].res(true)
                } else{
                    this.state.promptArr[0].res(false)
                }
                this.setState({
                    promptArr: this.state.promptArr.slice(1)
                })
            }
    
            return (
                //prompt with handler
                <ReceiverPrompt view="desktop" open={true}  name={this.state.promptArr[0].name} result={(res)=>{handler(res)}} />
            )
        }
    }

    handlePrivateRoom = () => {
        let reg = /\w+(-)\w+(-)\w/g ;
        let roomName = this.props.match.params.id;
        let sender;
        if(this.props.location.state){
            sender  = this.props.location.state.sender;
            if(sender.name === 'master'){
                this.handleJoinRoom();
                return;
            }
        }
        if(reg.test(roomName) && roomName.length >= 12){
            let userInfo = JSON.parse(localStorage.getItem("auth"));
            if(userInfo && userInfo.ttl > +new Date){
                this.setState({setAuth:true,isSigned:true})
            } else {
                this.setState({setAuth:true,isSigned:false})
            }
        }  else {
            this.handleJoinRoom();
        }

    }

    handleJoinRoom = (custname)=> {

        let reg = /\w+(-)\w+(-)\w/g ;
        if(reg.test(this.props.match.params.id)){
            let roomName = this.props.match.params.id;
            let sender;
            if( this.props.location.state) {
                sender  = this.props.location.state.sender;
                if(sender.name === 'slave') {
                    if (sender.socketId){
                        this.context.teleport.joinRoom({
                            sourceSocket: sender.socketId,
                            nickname: localStorage.getItem("UserName")
                          },
                          () => {
                            this.setState({renderGif:false})
                          },
                          (err)=>{
                              console.log("ERROR SENDER NOT SET");
                              this.setState({
                                  errCode : "Room name does not exist!!",
                                  leaveRoom : true,
                              })
                          }
                        );
                    } else{
                        sender = {name:"slave"};
                        this.context.teleport.joinRoom({
                            roomName: roomName,
                            nickname: custname || localStorage.getItem("UserName")
                        },
                        () => {
                            this.setState({renderGif:false})
                        },
                        (err)=>{
                            console.log("ERROR SENDER NOT SET");
                            this.setState({
                                errCode : "Room name does not exist!!",
                                leaveRoom : true,
                            })
                        }
                        );
                    }
                } 
            } else{
                sender = {name:"slave"};
                this.context.teleport.joinRoom({
                    roomName: roomName,
                    nickname: custname || localStorage.getItem("UserName")
                  },
                  () => {
                    this.setState({renderGif:false})
                  },
                  (err)=>{
                      console.log("ERROR SENDER NOT SET");
                      this.setState({
                          errCode : "Room name does not exist!!",
                          leaveRoom : true,
                      })
                  }
                );
                
            }

            this.context.teleport.onDownload((status) => { 
                if(this.state.downloadStatus && (status.ratio ==0) ) {
                    status.ratio = 1;
                }
                this.setState({downloadStatus: status})
            })
            window.history.replaceState(null,"");
            if(sender.name === 'master' && sender.public === false){
                this.setState({fPrivate: true})
            }

            // handle qrcode code
            if(sender.name === 'master') {
                QRCode.toDataURL( window.location.href, (error, url) => {
                    if (error) console.error(error)
                        console.log("QR ERROR", url);
                    this.setState({ qrcode: url });
                  })
            }
            this.setState({ roomName : roomName , sender: sender})
        }else {
            this.setState({ leaveRoom : true, errCode : "Room name does not exist!!" })
        }
    }

    handleCreateRoomDialog = (success) => {

        if(success) {

            this.setState({
                userName : localStorage.getItem('UserName'),
                createRoomDialogFlag : false,
            })
            this.handlePrivateRoom();

        } else {

            this.setState({
                createRoomDialogFlag : true,
            })

        }

    }

    handleSaveChange = ({ name, isPublic }) => {

        localStorage.setItem('UserName', name);
        this.handleVisibility(isPublic);
        this.setState({
            roomIsPublic : isPublic,
            openSettings : false
        })

    } 

    handleLeaveRoom = () => {

        //leave room logic
        this.setState({ leaveRoom : true })
        
    }

    setFile = (fileList) => {

        this.context.teleport.setFiles(fileList);
        this.context.teleport.onChange();
        this.setState({
            files : fileList 
        })

    }

    handleFilePermission = (res) => {
        this.state.fileCallBack( res ? "string" : "");
        this.setState({
            fileOpen : false
        })
    }

    handleAudio = () => {
        let roomName  = this.state.roomName;
        let payload = roomName.toUpperCase().replace(/\s/g, '');
        let tpay = "";
        payload.split("").forEach(ele => {
            if(tpay.slice(-1) === ele){
                tpay += "_"
            }
            tpay += ele;
        })
        this.setState({ audioDisplay : false });
        tpay = tpay.replace(/-/g,"");
        this.state.analyzer.send(tpay,()=>{
            this.setState({ audioDisplay : true });
            })
      }

    renderSenderDeck = () => {

        return(
            <React.Fragment>
                <DropArea 
                analyzer={this.state.analyzer} 
                openDetails={this.state.openDetails} 
                roomChanged={this.state.sender.roomChanged} 
                roomName={this.state.roomName} 
                handleDetailClose={ ()=>{ this.setState({ openDetails : false }) } } 
                view="mobile" 
                onSendClick={(txt)=>{ this.sendTextContent(txt) }}
                textData={this.state.clipTextField}
                disabled={false} 
                getFile={this.setFile} 
                fileList={this.state.files} 
                />   
                <div className="footerMob" >
                    <RoomDetails handleClick={()=> { this.setState({ openDetails : !this.state.openDetails }) }} details = {this.state.openDetails} roomName={this.state.roomName} />
                    <LeaveRoomBtn handleClick={this.handleLeaveRoom} />
                </div>     
            </React.Fragment>
        )

    }

    renderGifs = () => {
        return(
            <React.Fragment>
                <Player
                autoplay
                loop
                src={this.state.renderGif ? connect:folder}
                style={ window.innerWidth < 900  ? { height: '45vw', width: '45vw' } : { height: '20vw', width: '20vw' } }
                >
                    <Controls visible={false} buttons={['play', 'repeat', 'frame', 'debug']} />
                </Player>
                <p style={{textAlign: 'center',marginTop: '15px'}}>{this.state.renderGif ? "Establishing Connection" : "Waiting for files"}</p>
            </React.Fragment>
        )
    }

    renderReceiverDeck = () => {

        if(this.state.downloadStatus) {
            const {file,ratio} = this.state.downloadStatus
            if(ratio === 1) {
                toast.info("Download Completed",{toastId:"111"})
                this.setState({downloadFiles: [...this.state.downloadFiles,file], downloadStatus : null});
            }
            if(ratio*100 == 99) {
                if (document.hidden && ('Notification' in window)) {
                    Notification.requestPermission((permission) => {
                      if(!('permission' in Notification)) {
                          Notification.permission = permission;
                      }
                      if (permission === "granted") {
                        navigator.serviceWorker.ready.then((registration) => {
                          registration.showNotification('Teleport',{ body: "Click to download file!",data:{href:window.location.href,name:""}});
                        });
                      }
                    });
                }
            }
            return(
                <React.Fragment>
                    <div className="dropAreaGif" >
                        <FileDownloadStatsBar view="mobile" fileName={file} value={Math.floor(ratio*100)} />
                    </div>
                    <div className="footerMob" >
                        <LeaveRoomBtn handleClick={this.handleLeaveRoom} />
                    </div>
                </React.Fragment>
            )
        } else {

            return(
                <React.Fragment>
                    <div className="dropAreaGif" >
                        {this.renderGifs()}
                    </div>
                    <div className="footerMob" >
                        <LeaveRoomBtn handleClick={this.handleLeaveRoom} />
                    </div>
                </React.Fragment>
            )

        }

    }

    renderDisplay = () => {

        if(this.state.displayComponent === 0){

            return(
                <div id="fileField" className="mainDeck" >
                    <div className="cog" >
                        <div className="logo" onClick={this.handleLeaveRoom} >
                            <Logo handleClick={()=>{ document.querySelector("#leaveRoomDesktop").click(); }} view="mobile" from="room" />
                        </div>
                        { this.state.sender.name === 'master' ? 
                            <div className="qr" >
                                <QrButton handleClick={()=>{  if(this.state.qrcode){ this.setState({ openQrPrompt : true })} }} />
                            </div> : 
                            null
                        }
                        <div className="audioShare" >
                          <ShareViaAudioIconButton className="audioShare" display={this.state.audioDisplay} handleClick={this.handleAudio} handleBadgeClick={()=>{ this.setState({ openAudioInfoPrompt : true }) }} />
                        </div>
                        <div className="settings" >
                         <SettingsIconBtn handleClick={() => { 
                            this.setState({ openSettings : true }) }} 
                            />
                        </div>
                    </div>
                    { this.state.sender.name === 'master' ? this.renderSenderDeck() : this.renderReceiverDeck() }
                </div>
            )

        } else if (this.state.displayComponent === 1){

            return(
                <div className="infoPanel" >
                    <div className="userInfo">
                    { this.state.sender.name === 'master' ? <UserInfo mode="Sender" /> : <UserInfo mode="Receiver" /> }
                    </div>
                    <div className="list" >
                        { this.state.sender.name === 'master' ? 
                            <ReceiverList status={this.state.curPeers} receivers={this.state.receivers} removeReceiver={(peerID)=>{ this.ejectPeer(peerID) }} /> :
                            <DownloadList  files={this.state.downloadFiles} sender={this.state.receivers}   />  
                        }
                    </div>
                </div>
            )

        }

    }

    render(){
        if(this.state.leaveRoom){ 
            return(
                <Redirect to={{
                    pathname : '/',
                    state : {
                        error : this.state.errCode,
                    }
                }} />
            )
        }
        if(this.state.sender){
            return(
                <div className={ this.state.openSettings || this.state.openDetails || this.state.fileOpen ? "bgMobBlur" : "roomMobContainer" } >
                    <div className="mainComponent" >
                        { this.renderDisplay() }
                    </div>
                    <BottomNavigation handleComponent={(val)=>{ this.setState({ displayComponent : val }) }} />
                    <SettingsDialog show={this.state.openSettings} privateRoom={this.state.fPrivate} handleSavedChanges={this.handleSaveChange} handleKeyChange={this.handleKeyChange} closeDialogCallBack={ (condition)=>{ this.setState({ openSettings : condition }) } } />
                    <SuccessToast message={this.state.successMsg} open={this.state.successToast} closeSnack={()=>{ this.setState({ successToast : false }) }} />
                    <FileSeedingStatusToast open={this.state.openToast} closeSnack={()=>{ this.setState({ openToast : false }) }} />
                    <FilePermissionDialog view="mobile" open={this.state.fileOpen} fileName={this.state.filePermList} result={this.handleFilePermission} />
                    <ReceiverTextPrompt open={this.state.openRoomTextPrompt} view="mobile" text={this.state.receiverClipText} closeBtnCallback={()=>{this.setState({openRoomTextPrompt : false})}} />
                    <InfoPrompt view="mobile" info="audio" open={this.state.openAudioInfoPrompt} handleClose={()=>{this.setState({ openAudioInfoPrompt : false })}} />
                    <QrPrompt qr={this.state.qrcode} view="mobile" open={this.state.openQrPrompt} handleClose={()=>{this.setState({ openQrPrompt : false })}} />
                    {this.renderUserPrompt()}
                </div>
            )
        } else {
            return (
            <React.Fragment>
                <Loader />
                <CreateRoomDialog show={this.state.createRoomDialogFlag} updatedNameCallBack={this.handleCreateRoomDialog} />
                <PrivatePrompt show={this.state.setAuth} signStatus={this.state.isSigned} handleClose={() => this.setState({setAuth:false})} handleJoinRoom={this.handleJoinRoom}  />
            </React.Fragment>
            )
        }
    }

}

export default Room;